/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/ActivityShimmer" />
import * as React from "react";

export interface IActivityShimmerProps {
    persona?: boolean;
    text?: boolean;
}

export const ActivityShimmer: React.FunctionComponent<IActivityShimmerProps> = props => {
    let { persona, text } = props;

    if (!persona && !text) {
        // if neither is shown, shown both
        persona = true;
        text = true;
    }

    return (
        <>
            {persona && <div className="shimmer shimmer-circle-medium"></div>}
            {text && <div className="shimmer shimmer-line" style={{ width: "150px", height: "24px" }}></div>}
        </>
    );
};
